import { sortBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

const DEFAULT_NOTIFICATION_SORT = (notif) => notif.sent_on;

export function useEventNotifications(eventId, { filter, sortBy: sortFunction = DEFAULT_NOTIFICATION_SORT } = {}) {
    const selectEventNotifications = useCallback((state) => state.events[eventId]?.notifications.all, [eventId]),
        notifications = useSelector(selectEventNotifications);

    return useMemo(() => {
        let result = notifications ?? [];

        if (filter) result = result.filter(filter);
        if (sortFunction) result = sortBy(result, sortFunction);

        return result;
    }, [notifications]);
}
